/* `/marketplace/listings` — an agent's category and tagline in the consumer app's marketplace.
   backend/modules/marketplace/README.md for the wire. Only the agents feature reads it, so it
   lives in this feature, not `shared/api` (rule book §1 rule 3).

   Paths are bare; `client.baseURL` carries `/api/v1`. Every response goes through `unwrap`. */
import { client } from "@/shared/api/client";
import { unwrap, type Envelope } from "@/shared/api/envelope";

import type { MarketplaceListing, MarketplaceListingSave } from "@/shared/types";

export const marketplaceKeys = {
  all: ["marketplace"] as const,
  listing: (agentId: string) => [...marketplaceKeys.all, "listing", agentId] as const,
};

/** One never saved reads empty. */
export async function getListing(agentId: string): Promise<MarketplaceListing> {
  return unwrap(await client.get<Envelope<MarketplaceListing>>(`/marketplace/listings/${agentId}`));
}

export async function saveListing(agentId: string, body: MarketplaceListingSave): Promise<MarketplaceListing> {
  return unwrap(await client.put<Envelope<MarketplaceListing>>(`/marketplace/listings/${agentId}`, body));
}
